import type { AxiosError } from 'axios';

export function isTokenInvalid(error: AxiosError): boolean {
  const data = error.response?.data as { error?: string };
  return ['invalid_token', 'invalid_grant', 'Unauthorized'].includes(data?.error ?? '');
}

export function redirectToRoot() {
  globalThis.location.href = '/';
}

export function redirectToUnlicensed() {
  if (!globalThis.location.href.includes('/unlicensed')) {
    globalThis.location.pathname = '/unlicensed';
  }
}
